import {usePreviewContext} from "../../context/PreviewContext";
import {metaDataProperty} from "./previewMetaData";

interface Props {
    metadataId?: string,
    propertyName?: string,
    children?: any
}
function PreviewPropertyHighlighter(props: Props) {
    const preview = usePreviewContext().isPreview;
    if (preview && props.propertyName) {
        return (<span {...metaDataProperty(preview, props.propertyName, props.metadataId)}>{props.children}</span>)
    } else {
        return props.children ? <>{props.children}</> : null;
    }
}
export default PreviewPropertyHighlighter;